/**
 * One chat turn over fetch, streamed. A copy of v2Stream
 * (screens/systemic-v2/v2Fetch.js) so this shared component does not depend on
 * one module's internals; the SSE framing is the backend's contract
 * (routes/systemicV2Turn.js): `text` frames { field, delta }, then one `done`
 * carrying the JSON body, or `error`. A plain JSON answer is accepted too.
 * A stream that ends without `done` throws with code CUT_OFF: the half-written
 * text is never passed off as the reply.
 */
function failure(res, data) {
  const message = data?.error?.message || data?.error || `HTTP ${res.status}`;
  const err = new Error(typeof message === 'string' ? message : JSON.stringify(message));
  err.status = res.status;
  err.code = data?.error?.code || null;
  return err;
}

export async function streamChat(url, body, onText) {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', Accept: 'text/event-stream' },
    body: JSON.stringify(body),
  });
  if (!String(res.headers.get('content-type') || '').includes('text/event-stream')) {
    const data = await res.json().catch(() => null);
    if (!res.ok || !data || data.success === false) throw failure(res, data);
    return data;
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const frames = buffer.split('\n\n');
    buffer = frames.pop();
    for (const frame of frames) {
      if (!frame.startsWith('data: ')) continue;
      const { event, data } = JSON.parse(frame.slice(6));
      if (event === 'text') onText?.(data.field, data.delta);
      else if (event === 'done') return data;
      else if (event === 'error') throw new Error(data?.message || 'Stream failed');
    }
  }
  const err = new Error('cut_off');
  err.code = 'CUT_OFF';
  throw err;
}
